import * as moment from 'moment';
import VueSweetalert2 from "vue-sweetalert2"
import Swal from "sweetalert2/dist/sweetalert2.js"
import "sweetalert2/dist/sweetalert2.min.css"
export default{
    Trim(strTexto) {
        // Substitúi os espaços vazios no inicio e no fim da string por vazio.
        return strTexto.replace(/^s+|s+$/g, '');
    },
    notif(tipo, mensagem) {
        if (tipo === 'error') {
            Swal.fire({
                icon: "error",
                title: "Erro ao processar registro",
                text: mensagem,

            });
        }else{

            Swal.fire({
                position: "top-end",
                icon: tipo,
                title: mensagem,
                showConfirmButton: false,
                timer: 1500
            });
        }
     
    },
    temapadraodraco(){
        return {
            nome               : 'Padrao Draco',
            corprimaria        : '#593196',
            corprimariasuave   : '#7c59c2',
            corbrilho          : '#a98bde',
            corsuperficie      : '#ffffff',
            corsuperficiesuave : '#f7f3ff',
            corborda           : '#dbcdf6',
            cortexto           : '#2c1a4d',
            corbarra           : '#31353d',
            cortextobarra      : '#b8bfce',
            corsanfonamenu     : '#3a3f48',
            cortextosanfona    : '#b8bfce',
            corhoversanfona    : '#a98bde'
        };
    },
    normalizarcorhex(cor, fallback){
        const fall = typeof fallback === "string" ? fallback : '#593196';
        if (typeof cor !== "string"){
            return fall;
        }
        const valor = cor.trim();
        return /^#[0-9a-fA-F]{6}$/.test(valor) ? valor.toLowerCase() : fall;
    },
    normalizartemafilial(temaFonte){
        const padrao = this.temapadraodraco();
        let tema = {};

        if (typeof temaFonte === "string" && temaFonte.trim() !== ""){
            try {
                tema = JSON.parse(temaFonte);
            } catch (error) {
                tema = {};
            }
        }else if (typeof temaFonte === "object" && temaFonte !== null){
            tema = temaFonte;
        }

        return {
            nome               : (tema.nome || padrao.nome).toString(),
            corprimaria        : this.normalizarcorhex(tema.corprimaria, padrao.corprimaria),
            corprimariasuave   : this.normalizarcorhex(tema.corprimariasuave, padrao.corprimariasuave),
            corbrilho          : this.normalizarcorhex(tema.corbrilho, padrao.corbrilho),
            corsuperficie      : this.normalizarcorhex(tema.corsuperficie, padrao.corsuperficie),
            corsuperficiesuave : this.normalizarcorhex(tema.corsuperficiesuave, padrao.corsuperficiesuave),
            corborda           : this.normalizarcorhex(tema.corborda, padrao.corborda),
            cortexto           : this.normalizarcorhex(tema.cortexto, padrao.cortexto),
            corbarra           : this.normalizarcorhex(tema.corbarra, padrao.corbarra),
            cortextobarra      : this.normalizarcorhex(tema.cortextobarra, padrao.cortextobarra),
            corsanfonamenu     : this.normalizarcorhex(tema.corsanfonamenu, padrao.corsanfonamenu),
            cortextosanfona    : this.normalizarcorhex(tema.cortextosanfona, padrao.cortextosanfona),
            corhoversanfona    : this.normalizarcorhex(tema.corhoversanfona, padrao.corhoversanfona)
        };
    },
    aplicartemafilial(temaFonte){
        const tema = this.normalizartemafilial(temaFonte);
        if (typeof document !== "undefined" && document.documentElement){
            const root = document.documentElement;
            root.style.setProperty('--draco-purple', tema.corprimaria);
            root.style.setProperty('--draco-purple-soft', tema.corprimariasuave);
            root.style.setProperty('--draco-purple-glow', tema.corbrilho);
            root.style.setProperty('--draco-surface', tema.corsuperficie);
            root.style.setProperty('--draco-surface-soft', tema.corsuperficiesuave);
            root.style.setProperty('--draco-border', tema.corborda);
            root.style.setProperty('--draco-text', tema.cortexto);
            root.style.setProperty('--draco-nav-bg', tema.corbarra);
            root.style.setProperty('--draco-nav-text', tema.cortextobarra);
            root.style.setProperty('--draco-nav-accordion-bg', tema.corsanfonamenu);
            root.style.setProperty('--draco-nav-accordion-text', tema.cortextosanfona);
            root.style.setProperty('--draco-nav-accordion-hover', tema.corhoversanfona);
        }
        return tema;
    },
    logoff(context){
        let payload = {
            id          : null,
            nome        : '',
            dbcliente   : '',
            descgrupo   : '',
            dbcliente   : '',
            sistema     : '',
            todasfiliais: null            
        };
        context.$store.commit('MUDAR_USUARIO_LOGADO',payload);
        const temapadrao = this.temapadraodraco();
        context.$store.commit('MUDAR_TEMA_SISTEMA', temapadrao);
        this.aplicartemafilial(temapadrao);
        if (typeof document !== "undefined" && document.body){
            document.body.classList.remove('draco-sidenav-open');
        }
        window.localStorage.removeItem('dbcliente');
        window.localStorage.removeItem('idcliente');
        window.localStorage.removeItem('idusuario');
        window.localStorage.removeItem('nomeusu');
        window.localStorage.removeItem('senhausu');
        window.localStorage.removeItem('dthracesso');
        this.gotoprincipal();
        setTimeout(function(){
            $('#edidcliente').focus();
        }, 200); 
    },
    gotoprincipal(){
        window.location.href = '/';
    },
    formatarvalor(value, cifra) {
        var val = (value / 1).toFixed(2).replace('.', ',');
        if (cifra == '') {
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        } else {
            return cifra + ' ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
    },
    formatavalordecimais(valor, digitos) {
        //return valor.toLocaleString('pt-br', {minimumFractionDigits: digitos});
        //return valor.toFixed(digitos).replace('.', ',');        
        return valor.formatMoney(digitos, "", ".", ",");
    },    
    formatarzeros(str, length) {
        const resto = length - String(str).length;
        return '0'.repeat(resto > 0 ? resto : '0') + str;
    },
    formatardataDB (value){
        let ano = ""; let mes = ""; let dia = "";

        if(value.length < 10){
            ano = value.substring(4, 10);
            mes = value.substring(2, 4);
            dia = value.substring(0, 2);
        }else {
            ano = value.substring(6, 10);
            mes = value.substring(3, 5);
            dia = value.substring(0, 2);
        }
        return ano+'-'+mes+'-'+dia;
    },
    formatadatahrdb(strdatadb){
        let stsubstituida = strdatadb.replace(" ", "T");
        let dthr = stsubstituida.split("T");
        let res  = dthr[0].split("-");
        let resh = stsubstituida.split("T");
        let hr   = resh[1].split(":");
        let retstr = res[2]+'/'+res[1]+'/'+res[0]+'T'+hr[0]+':'+hr[1];
        return retstr;
    },        
    formatarvalorDB (value){
        return isNaN(value) === false ? parseFloat(value) :   parseFloat(value.replace("R$","").replace(".","").replace(",","."));
    },
    reqaxios(parametros, metodo, url){
        let axios        = require('axios');
        let bodyFormData = new FormData(); 

        for (let i = 0; i < parametros.length; i++){
            let pmt = parametros[i].parametro;
            let vl  = parametros[i].valor;
            bodyFormData.append(pmt, vl);    
        }
        return axios({
            method: metodo,
            //url: 'https://www.rillsoft-app.cloud/'+url,
            url : 'https://'+url,
            data: bodyFormData,
            headers: {'Content-Type': 'multipart/form-data' }            
        });           
    },
    verificasessao(context){
        let payloads = {
            fechar    : true
        };
        context.$store.commit('SIDE_NAV_CHANGE',payloads); 
        this.atzverificalib(context, true); 
        if (window.localStorage.getItem('adrsrv') === null){
            this.logoff(context);
            return false;
        }
        if (window.localStorage.getItem('idusuario') !== null) {
        //     let dthratual = moment();
        //     let dthracesso = moment(window.localStorage.getItem('dthracesso'));
        //     let dif = dthratual.diff(dthracesso, 'minutes');
        //     if (parseInt(dif) > 30) {
        //         this.logoff(context);
        //         return false;
        //     } else {
        //         return true;
        //     }
        // }else{
        //     this.logoff(context);
        //     return false;
            return true;
        }
    },
    InverterData(data) {
        let dia = data.substring(0, 2);
        let mes = data.substring(3, 5);
        let ano = data.substring(6, 10);
        return ano + '-' + mes + '-' + dia;
    },    
    DataAtual(barra, pegahora) {
        var datacompleta = new Date();
        var imes = datacompleta.getMonth();
        var strhora = "";
        if (pegahora){
            var hora    = datacompleta.getHours()+ "";          // 0-23
            var min     = datacompleta.getMinutes()+ "";        // 0-59
            var seg     = datacompleta.getSeconds()+ "";        // 0-59
    
            if (hora.length == 1) {
                hora = "0" + hora;
            }
            if (min.length == 1) {
                min = "0" + min;
            }
            if (seg.length == 1) {
                seg = "0" + seg;
            }
            strhora     = ' '+hora+':'+min+':'+seg;
        }
        ++imes;
        var mesabrev = imes + "";
        if (mesabrev.length == 1) {
            mesabrev = "0" + mesabrev;
        }
        var dataabrev = datacompleta.getDate() + "";
    
        if (dataabrev.length == 1) {
            dataabrev = "0" + dataabrev;
        }
        var anoatual = datacompleta.getFullYear();
        if (barra) {
            return dataabrev + '/' + mesabrev + '/' + anoatual + strhora;
        } else {
            return dataabrev + mesabrev + anoatual + strhora;
        }
    },
    formatResult(item) {
        if (!item.id) {
            return item.text;
        }
        return $('<p style="font-size:12px; font-weight: bold;">' + item.id + '</p><b><p style="font-size:12px; font-weight: bold;">' + item.text + '</p></b>');
    },
    formatSelection(item) {
        return $('<p style="font-size:12px; font-weight: bold;">' + item.text + '</p>');
    },
    getArrayIndexForKey(arr, key, val) {//pega o índice de uma array pela chave
        for (var i = 0; i < arr.length; i++) {
            if (arr[i][key] == val) return i;
        }
        return -1;
    },
    findValInArray(arr, key, val) {//verifica se existe um valor em uma chave de uma array
        if (arr) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i][key] == val) return true;
            }
        }
        return false;
    },
    getValInArray(arr, key, val, keyret) {//verifica se existe um valor em uma chave de uma array
        let valret = 0;
        if (arr) {
            for (var i = 0; i < arr.length; i++) {
                let valkey = arr[i][key];
                if (valkey == val) {
                    return arr[i][keyret];
                }
            }
        }
        return valret;
    },
    toTop(){
        $('html, body').animate({
            scrollTop: 0
        }, 200, 'linear');
    },
    moveindexarray(arr, old_index, new_index){
        if (new_index <= arr.length - 1 && new_index >= 0) {
            while (old_index < 0) {
                old_index += arr.length;
            }
            while (new_index < 0) {
                new_index += arr.length;
            }
            if (new_index >= arr.length) {
                var k = new_index - arr.length + 1;
                while (k--) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr;
        }else{
            return arr;
        }
        //Exemplo de uso
        //this.lsttmp = util.moveindexarray(this.lsttmp, old_index, new_index);
        //<button type="button" @click.prevent="mtdmoveindexarray(index, index - 1)" class="btn btn-primary btn-sm" style="margin-right: 5px;">Up</button>
        //<button type="button" @click.prevent="mtdmoveindexarray(index, index + 1)" class="btn btn-secondary btn-sm">Down</button>
    },
    opcaousuario(codop, perfil){
        let ret = parseInt(perfil[this.getArrayIndexForKey(perfil, 'codop', codop)].habilita) === 0 ? false : true;
        return ret;
    },
    calculacustoproduto(context, pipi, picms, pfrete, vsubst, ppis, pcofins, poutros, prcompra, prvenda, formula) {
        try {
            String.prototype.replaceAll = function (match, replace) {//função para substituir todas as ocorrências de uma string
                return this.split(match).join(replace);
            };
            let formulamontada = formula;

            formulamontada = formulamontada.replaceAll('PC', prcompra);
            formulamontada = formulamontada.replaceAll('IPI', pipi);
            formulamontada = formulamontada.replaceAll('ICM', picms);
            formulamontada = formulamontada.replaceAll('STB', vsubst);
            formulamontada = formulamontada.replaceAll('FT', pfrete);
            formulamontada = formulamontada.replaceAll('OT', poutros);
            formulamontada = formulamontada.replaceAll('PIS', ppis);
            formulamontada = formulamontada.replaceAll('COF', pcofins);
            formulamontada = formulamontada.replaceAll('PV', prvenda);

            let custocalculado = eval(formulamontada);
            return parseFloat(custocalculado);
        } catch (e) {
            //context.$toastr.e('Erro ao tentar calcular custo do produto. Verifique no cadastro da filial a fórmula e tente novamente!', 'Informação!');
            return 0;
        }
    },
    formatacpfcnpj(v) {
        //Remove tudo o que não é dígito
        if (v !== null){
            v = v.replace(/\D/g, "");
            if (v.length < 14) { //CPF
                //Coloca um ponto entre o terceiro e o quarto dígitos
                v = v.replace(/(\d{3})(\d)/, "$1.$2")
                //Coloca um ponto entre o terceiro e o quarto dígitos
                //de novo (para o segundo bloco de números)
                v = v.replace(/(\d{3})(\d)/, "$1.$2")
                //Coloca um hífen entre o terceiro e o quarto dígitos
                v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
            } else { //CNPJ
                //Coloca ponto entre o segundo e o terceiro dígitos
                v = v.replace(/^(\d{2})(\d)/, "$1.$2")
                //Coloca ponto entre o quinto e o sexto dígitos
                v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
                //Coloca uma barra entre o oitavo e o nono dígitos
                v = v.replace(/\.(\d{3})(\d)/, ".$1/$2")
                //Coloca um hífen depois do bloco de quatro dígitos
                v = v.replace(/(\d{4})(\d)/, "$1-$2")
            }
        }
        return v;
    },
    validarCNPJ(cnpj) {

        cnpj = cnpj.replace(/[^\d]+/g,'');

        if(cnpj === '') return false;

        if (cnpj.length != 14)
            return false;

        // Elimina CNPJs invalidos conhecidos
        if (cnpj == "00000000000000" ||
            cnpj == "11111111111111" ||
            cnpj == "22222222222222" ||
            cnpj == "33333333333333" ||
            cnpj == "44444444444444" ||
            cnpj == "55555555555555" ||
            cnpj == "66666666666666" ||
            cnpj == "77777777777777" ||
            cnpj == "88888888888888" ||
            cnpj == "99999999999999")
            return false;

        // Valida DVs
        let tamanho = cnpj.length - 2;
        let numeros = cnpj.substring(0,tamanho);
        let digitos = cnpj.substring(tamanho);
        let soma    = 0;
        let pos     = tamanho - 7;
        let i       = 0;
        for (i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0))
            return false;

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0,tamanho);
        soma    = 0;
        pos     = tamanho - 7;
        i       = 0;
        for (i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1))
            return false;

        return true;
    },
    validarCPF(cpf) {
        cpf = cpf.replace(/[^\d]+/g,'');

        if(cpf === '') return false;
        // Elimina CPFs invalidos conhecidos
        if (cpf.length != 11 ||
            cpf == "00000000000" ||
            cpf == "11111111111" ||
            cpf == "22222222222" ||
            cpf == "33333333333" ||
            cpf == "44444444444" ||
            cpf == "55555555555" ||
            cpf == "66666666666" ||
            cpf == "77777777777" ||
            cpf == "88888888888" ||
            cpf == "99999999999")
            return false;
        // Valida 1o digito
        let add = 0;
        let i = 0;
        for (i=0; i < 9; i ++)
            add += parseInt(cpf.charAt(i)) * (10 - i);
        let rev = 11 - (add % 11);
        if (rev === 10 || rev === 11)
            rev = 0;
        if (rev != parseInt(cpf.charAt(9)))
            return false;
        // Valida 2o digito
        add = 0;
        for (let i = 0; i < 10; i ++)
            add += parseInt(cpf.charAt(i)) * (11 - i);
        rev = 11 - (add % 11);
        if (rev === 10 || rev === 11)
            rev = 0;
        if (rev != parseInt(cpf.charAt(10)))
            return false;
        return true;
    },
    validarIE(ie, estado) {

        if (ie === "ISENTO")
            return true;

        ie = ie.replace(/[^\d]+/g, '');

        let b = 0, soma = 0, dig = 0, nro = 0, resto = 0, i = 0, die = 0, s = 0, resultado = 0, p = 0, n = 0;

        switch (estado) {

            case "AC":
                //01.538.221/213-25  <--- EXEMPLO

                if (ie.length != 13)
                    return false;
                b = 4;
                soma = 0;
                for (let i = 0; i <= 10; i++) {
                    soma += parseInt(ie.charAt(i)) * b;
                    --b;
                    if (b === 1)
                        b = 9;
                }
                dig = 11 - (soma % 11);
                if (dig >= 10)
                    dig = 0;
                if (dig != parseInt(ie.charAt(11)))
                    return false;
                b = 5;
                soma = 0;
                for (let i = 0; i <= 11; i++) {
                    soma += parseInt(ie.charAt(i)) * b;
                    --b;
                    if (b === 1)
                        b = 9;
                }
                dig = 11 - (soma % 11);
                if (dig >= 10)
                    dig = 0;
                return (dig === parseInt(ie.charAt(12)));
                break;

            case "AL":
                //248831593

                if (ie.length != 9)
                    return false;
                b = 9;
                soma = 0;
                for (let i = 0; i <= 7; i++) {
                    soma += parseInt(ie.charAt(i)) * b;
                    --b;
                }
                soma *= 10;
                dig = soma - (Math.floor(soma / 11) * 11);
                if (dig === 10)
                    dig = 0;
                return (dig === parseInt(ie.charAt(8)));
                break;

            case "AM":
                //85.036.459-0

                if (ie.length != 9)
                    return false;
                b = 9;
                soma = 0;
                for (let i = 0; i <= 7; i++) {
                    soma += parseInt(ie.charAt(i)) * b;
                    b--;
                }
                if (soma < 11) {
                    dig = 11 - soma;
                }
                else {
                    let i = soma % 11;
                    if (i <= 1) {
                        dig = 0;
                    }
                    else {
                        dig = 11 - i;
                    }
                }
                return (dig === parseInt(ie.charAt(8)));
                break;

            case "AP":
                //033249547

                if (ie.length != 9)
                    return false;
                if (ie.substring(0, 2) != "03")
                    return false;
                let p = 0, d = 0, i = ie.substring(1, 8);
                if ((i >= 3000001) && (i <= 3017000)) {
                    p = 5;
                    d = 0;
                }
                else if ((i >= 3017001) && (i <= 3019022)) {
                    p = 9;
                    d = 1;
                }
                b = 9;
                soma = p;
                for (let i = 0; i <= 7; i++) {
                    soma += parseInt(ie.charAt(i)) * b;
                    b--;
                }
                dig = 11 - (soma % 11);
                if (dig === 10) {
                    dig = 0;
                }
                else if (dig === 11) {
                    dig = d;
                }
                return (dig === parseInt(ie.charAt(8)));
                break;

            case "BA":
                //902919-12

                if (ie.length === 8) {
                    die = ie.substring(0, 8);
                    nro = new Array(8);
                    dig = -1;
                    for (let i = 0; i <= 7; i++)
                        nro[i] = parseInt(die.charAt(i));
                    let NumMod = 0;
                    if (String(nro[0]).match(/[0123458]/)) {
                        NumMod = 10;
                    }
                    else {
                        NumMod = 11;
                    }
                    b = 7;
                    soma = 0;
                    for (let i = 0; i <= 5; i++) {
                        soma += nro[i] * b;
                        b--;
                    }
                    i = soma % NumMod;
                    if (NumMod === 10) {
                        if (i === 0) {
                            dig = 0;
                        } else {
                            dig = NumMod - i;
                        }
                    }
                    else {
                        if (i <= 1) {
                            dig = 0;
                        } else {
                            dig = NumMod - i;
                        }
                    }
                    resultado = (dig === nro[7]);
                    if (!resultado)
                        return false;
                    b = 8;
                    soma = 0;
                    for (let i = 0; i <= 5; i++) {
                        soma += nro[i] * b;
                        b--;
                    }
                    soma += nro[7] * 2;
                    i = soma % NumMod;
                    if (NumMod === 10) {
                        if (i === 0) {
                            dig = 0;
                        } else {
                            dig = NumMod - i;
                        }
                    }
                    else {
                        if (i <= 1) {
                            dig = 0;
                        } else {
                            dig = NumMod - i;
                        }
                    }
                    return (dig === nro[6]);
                }

                if (ie.length === 9) {
                    die = ie.substring(0, 9);
                    nro = new Array(9);
                    dig = -1;
                    for (let i = 0; i <= 8; i++)
                        nro[i] = parseInt(die.charAt(i));
                    let NumMod = 0;
                    if (String(nro[0]).match(/[0123458]/)) {
                        NumMod = 10;
                    }
                    else {
                        NumMod = 11;
                    }
                    b = 8;
                    soma = 0;
                    for (let i = 0; i <= 6; i++) {
                        soma += nro[i] * b;
                        b--;
                    }
                    i = soma % NumMod;
                    if (NumMod === 10) {
                        if (i === 0) {
                            dig = 0;
                        } else {
                            dig = NumMod - i;
                        }
                    }
                    else {
                        if (i <= 1) {
                            dig = 0;
                        } else {
                            dig = NumMod - i;
                        }
                    }
                    resultado = (dig === nro[8]);
                    if (!resultado)
                        return false;
                    b = 9;
                    soma = 0;
                    for (i = 0; i <= 6; i++) {
                        soma += nro[i] * b;
                        b--;
                    }
                    soma += nro[8] * 2;
                    i = soma % NumMod;
                    if (NumMod === 10) {
                        if (i === 0) {
                            dig = 0;
                        } else {
                            dig = NumMod - i;
                        }
                    }
                    else {
                        if (i <= 1) {
                            dig = 0;
                        } else {
                            dig = NumMod - i;
                        }
                    }
                    return (dig === nro[7]);
                }

                return false;
                break;

            case "CE":
                //03964139-2

                if (ie.length != 9)
                    return false;
                die = ie;
                nro = Array(9);
                for (let i = 0; i <= 8; i++)
                    nro[i] = parseInt(die[i]);
                b = 9;
                soma = 0;
                for (let i = 0; i <= 7; i++) {
                    soma += nro[i] * b;
                    b--;
                }
                dig = 11 - (soma % 11);
                if (dig >= 10)
                    dig = 0;
                return (dig === nro[8]);
                break;

            case "DF":
                //07500572001-15

                if (ie.length != 13)
                    return false;
                nro = new Array(13);
                for (let i = 0; i <= 12; i++)
                    nro[i] = parseInt(ie.charAt(i));
                b = 4;
                soma = 0;
                for (let i = 0; i <= 10; i++) {
                    soma += nro[i] * b;
                    b--;
                    if (b === 1)
                        b = 9;
                }
                dig = 11 - (soma % 11);
                if (dig >= 10)
                    dig = 0;
                if (dig != nro[11])
                    return false;
                b = 5;
                soma = 0;
                for (let i = 0; i <= 11; i++) {
                    soma += nro[i] * b;
                    b--;
                    if (b === 1)
                        b = 9;
                }
                dig = 11 - (soma % 11);
                if (dig >= 10)
                    dig = 0;
                return (dig === nro[12]);
                break;

            case "ES":
                //95936403-0

                if (ie.length != 9)
                    return false;
                nro = new Array(9);
                for (let i = 0; i <= 8; i++)
                    nro[i] = parseInt(ie.charAt(i));
                b = 9;
                soma = 0;
                for (let i = 0; i <= 7; i++) {
                    soma += nro[i] * b;
                    b--;
                }
                i = soma % 11;
                if (i < 2) {
                    dig = 0;
                } else {
                    dig = 11 - i;
                }
                return (dig === nro[8]);
                break;

            case "GO":
                //11.621.869-0

                if (ie.length != 9)
                    return false;
                s = ie.substring(0, 2);
                if ((s === '10') || (s === '11') || (s === '15')) {
                    nro = new Array(9);
                    for (let i = 0; i <= 8; i++)
                        nro[i] = parseInt(ie.charAt(i));
                    //n = Math.floor(ie / 10);
                    n = parseInt(ie.substring(0, 7));
                    if (n = 11094402) {
                        if ((nro[8] === 0) || (nro[8] === 1))
                            return true;
                    }
                    b = 9;
                    soma = 0;
                    for (i = 0; i <= 7; i++) {
                        soma += nro[i] * b;
                        b--;
                    }
                    let i = 0;
                    i = soma % 11;
                    dig = 0;
                    if (i === 0)
                        dig = 0;
                    else {
                        if (i === 1) {
                            if ((n >= 10103105) && (n <= 10119997))
                                dig = 1;
                            else
                                dig = 0;
                        }
                        else
                            dig = 11 - i;
                    }
                    return (dig === nro[8]);
                }
                return false;
                break;

            case "MA":
                //12785611-0

                if (ie.length != 9)
                    return false;
                if (ie.substring(0, 2) != "12")
                    return false;
                nro = new Array(9);
                for (let i = 0; i <= 8; i++)
                    nro[i] = parseInt(ie.charAt(i));
                b = 9;
                soma = 0;
                i = 0;
                for (let i = 0; i <= 7; i++) {
                    soma += nro[i] * b;
                    b--;
                }
                i = soma % 11;
                if (i <= 1) {
                    dig = 0;
                } else {
                    dig = 11 - i;
                }
                return (dig === nro[8]);
                break;

            case "MG":
                //987.674.893/7788

                if (ie.length != 13)
                    return false;
                let dig1 = ie.substring(11, 12);
                let dig2 = ie.substring(12, 13);
                let inscC = ie.substring(0, 3) + '0' + ie.substring(3, 11);
                let insc = inscC.split('');
                let npos = 11;
                i = 1;
                let ptotal = 0;
                let psoma = 0;
                while (npos >= 0) {
                    i++;
                    psoma = parseInt(insc[npos]) * i;
                    if (psoma >= 10)
                        psoma -= 9;
                    ptotal += psoma;
                    if (i === 2)
                        i = 0;
                    npos--;
                }
                let nresto = ptotal % 10;
                if (nresto === 0)
                    nresto = 10;
                nresto = 10 - nresto;
                if (nresto != parseInt(dig1))
                    return false;
                npos = 11;
                i = 1;
                ptotal = 0;
                let is = ie.split('');
                while (npos >= 0) {
                    i++;
                    if (i === 12)
                        i = 2;
                    ptotal += parseInt(is[npos]) * i;
                    npos--;
                }
                nresto = ptotal % 11;
                if ((nresto === 0) || (nresto === 1))
                    nresto = 11;
                nresto = 11 - nresto;
                return (nresto === parseInt(dig2));
                break;

            case "MS":
                //28798270-0

                if (ie.length != 9)
                    return false;
                if (ie.substring(0, 2) != "28")
                    return false;
                nro = new Array(9);
                for (let i = 0; i <= 8; i++)
                    nro[i] = parseInt(ie.charAt(i));
                b = 9;
                soma = 0;
                i = 0;
                for (i = 0; i <= 7; i++) {
                    soma += nro[i] * b;
                    b--;
                }
                i = soma % 11;
                dig = 0;
                if (i <= 1) {
                    dig = 0;
                } else {
                    dig = 11 - i;
                }
                return (dig === nro[8]);
                break;

            case "MT":
                //5862355183-9

                if (ie.length != 11)
                    return false;
                die = ie;
                nro = new Array(11);
                for (let i = 0; i <= 10; i++)
                    nro[i] = parseInt(die[i]);
                b = 3;
                soma = 0;
                i = 0;
                for (let i = 0; i <= 9; i++) {
                    soma += nro[i] * b;
                    b--;
                    if (b === 1)
                        b = 9;
                }
                i = soma % 11;
                dig = 0;
                if (i <= 1) {
                    dig = 0;
                } else {
                    dig = 11 - i;
                }
                return (dig === nro[10]);
                break;

            case "PA":

                if (ie.length != 9)
                    return false;
                if (ie.substring(0, 2) != '15')
                    return false;
                nro = new Array(9);
                for (let i = 0; i <= 8; i++)
                    nro[i] = parseInt(ie.charAt(i));
                b = 9;
                soma = 0;
                for (let i = 0; i <= 7; i++) {
                    soma += nro[i] * b;
                    b--;
                }
                i = soma % 11;
                dig = 0;
                if (i <= 1)
                    dig = 0;
                else
                    dig = 11 - i;
                return (dig === nro[8]);
                break;

            case "PB":
                //99602471-9

                if (ie.length != 9)
                    return false;
                nro = new Array(9);
                for (let i = 0; i <= 8; i++)
                    nro[i] = parseInt(ie.charAt(i));
                b = 9;
                soma = 0;
                for (let i = 0; i <= 7; i++) {
                    soma += nro[i] * b;
                    b--;
                }
                i = soma % 11;
                dig = 0;
                if (i <= 1)
                    dig = 0;
                else
                    dig = 11 - i;
                return (dig === nro[8]);
                break;

            case "PE":
                //3138399-80

                // IE antiga com 14 digitos
                if (ie.length === 14) {
                    nro = new Array(14);
                    for (let i = 0; i <= 13; i++)
                        nro[i] = parseInt(ie.charAt(i));
                    b = 5;
                    soma = 0;
                    for (let i = 0; i <= 12; i++) {
                        soma += nro[i] * b;
                        b--;
                        if (b === 0)
                            b = 9;
                    }
                    dig = 11 - (soma % 11);
                    if (dig > 9)
                        dig = dig - 10;
                    return (dig === nro[13]);
                }

                // IE nova com 9 digitos
                if (ie.length === 9) {
                    nro = new Array(9);
                    for (let i = 0; i <= 8; i++)
                        nro[i] = parseInt(ie.charAt(i));
                    b = 8;
                    soma = 0;
                    for (let i = 0; i <= 6; i++) {
                        soma += nro[i] * b;
                        b--;
                    }
                    i = soma % 11;
                    dig = 0;
                    if (i <= 1) {
                        dig = 0;
                    } else {
                        dig = 11 - i;
                    }
                    if (dig != nro[7])
                        return false;
                    b = 9;
                    soma = 0;
                    for (let i = 0; i <= 7; i++) {
                        soma += nro[i] * b;
                        b--;
                    }
                    i = soma % 11;
                    if (i <= 1) {
                        dig = 0;
                    } else {
                        dig = 11 - i;
                    }
                    return (dig === nro[8]);
                }

                return false;
                break;

            case "PI":
                //45911762-9

                if (ie.length != 9)
                    return false;
                nro = new Array(9);
                for (let i = 0; i <= 8; i++)
                    nro[i] = parseInt(ie.charAt(i));
                b = 9;
                soma = 0;
                for (let i = 0; i <= 7; i++) {
                    soma += nro[i] * b;
                    b--;
                }
                i = soma % 11;
                dig = 0;
                if (i <= 1) {
                    dig = 0;
                } else {
                    dig = 11 - i;
                }
                return (dig === nro[8]);
                break;

            case "PR":
                //091.32436-92

                if (ie.length != 10)
                    return false;
                nro = new Array(10);
                for (let i = 0; i <= 9; i++)
                    nro[i] = parseInt(ie.charAt(i));
                b = 3;
                soma = 0;
                for (let i = 0; i <= 7; i++) {
                    soma += nro[i] * b;
                    b--;
                    if (b === 1)
                        b = 7;
                }
                i = soma % 11;
                dig = 0;
                if (i <= 1)
                    dig = 0;
                else
                    dig = 11 - i;
                if (dig != nro[8])
                    return false;
                b = 4;
                soma = 0;
                for (let i = 0; i <= 8; i++) {
                    soma += nro[i] * b;
                    b--;
                    if (b === 1)
                        b = 7;
                }
                i = soma % 11;
                if (i <= 1)
                    dig = 0;
                else
                    dig = 11 - i;
                return (dig === nro[9]);
                break;

            case "RJ":
                //33.671.00-8

                if (ie.length != 8)
                    return false;
                nro = new Array(8);
                for (let i = 0; i <= 7; i++)
                    nro[i] = parseInt(ie.charAt(i));
                b = 2;
                soma = 0;
                for (let i = 0; i <= 6; i++) {
                    soma += nro[i] * b;
                    b--;
                    if (b === 1)
                        b = 7;
                }
                i = soma % 11;
                dig = 0;
                if (i <= 1) {
                    dig = 0;
                } else {
                    dig = 11 - i;
                }
                return (dig === nro[7]);
                break;

            case "RN":
                //20.456.122-1

                if (ie.substring(0, 2) != '20')
                    return false;

                // IE com 9 digitos
                if (ie.length === 9) {
                    nro = new Array(9);
                    for (let i = 0; i <= 8; i++)
                        nro[i] = parseInt(ie.charAt(i));
                    b = 9;
                    soma = 0;
                    for (let i = 0; i <= 7; i++) {
                        soma += nro[i] * b;
                        b--;
                    }
                    soma *= 10;
                    dig = soma % 11;
                    if (dig === 10)
                        dig = 0;
                    return (dig === nro[8]);
                }

                // IE com 10 digitos
                if (ie.length === 10) {
                    nro = new Array(10);
                    for (let i = 0; i <= 9; i++)
                        nro[i] = parseInt(ie.charAt(i));
                    b = 10;
                    soma = 0;
                    for (let i = 0; i <= 8; i++) {
                        soma += nro[i] * b;
                        b--;
                    }
                    soma *= 10;
                    dig = soma % 11;
                    if (dig === 10)
                        dig = 0;
                    return (dig === nro[9]);
                }

                return false;
                break;

            case "RO":
                //6472648568841-4

                if (ie.length != 14)
                    return false;
                nro = new Array(14);
                b = 6;
                soma = 0;
                for (let i = 0; i <= 12; i++) {
                    nro[i] = parseInt(ie.charAt(i));
                    soma += nro[i] * b;
                    b--;
                    if (b === 1)
                        b = 9;
                }
                dig = 11 - ( soma % 11);
                if (dig >= 10)
                    dig = dig - 10;
                return (dig === parseInt(ie.charAt(13)));
                break;

            case "RR":

                if (ie.length != 9)
                    return false;
                if (ie.substring(0, 2) != "24")
                    return false;
                nro = new Array(9);
                for (let i = 0; i <= 8; i++)
                    nro[i] = parseInt(ie.charAt(i));
                soma = 0;
                n = 0;
                for (let i = 0; i <= 7; i++)
                    soma += nro[i] * ++n;
                dig = soma % 9;
                return (dig === nro[8]);
                break;

            case "RS":
                //909/7020560

                if (ie.length != 10)
                    return false;
                nro = new Array(10);
                for (let i = 0; i <= 9; i++)
                    nro[i] = parseInt(ie.charAt(i));
                b = 2;
                soma = 0;
                for (let i = 0; i <= 8; i++) {
                    soma += nro[i] * b;
                    b--;
                    if (b === 1)
                        b = 9;
                }
                dig = 11 - (soma % 11);
                if (dig >= 10)
                    dig = 0;
                return (dig === nro[9]);
                break;

            case "SC":
                //496.160.400

                if (ie.length != 9)
                    return false;
                nro = new Array(9);
                for (let i = 0; i <= 8; i++)
                    nro[i] = parseInt(ie.charAt(i));
                b = 9;
                soma = 0;
                for (let i = 0; i <= 7; i++) {
                    soma += nro[i] * b;
                    b--;
                }
                i = soma % 11;
                dig = 0;
                if (i <= 1)
                    dig = 0;
                else
                    dig = 11 - i;
                return (dig === nro[8]);
                break;

            case "SE":

                if (ie.length != 9)
                    return false;
                nro = new Array(9);
                for (let i = 0; i <= 8; i++)
                    nro[i] = parseInt(ie.charAt(i));
                b = 9;
                soma = 0;
                for (let i = 0; i <= 7; i++) {
                    soma += nro[i] * b;
                    b--;
                }
                dig = 11 - (soma % 11);
                if (dig >= 10)
                    dig = 0;
                return (dig === nro[8]);
                break;

            case "SP":
                //260.252.504.510

                if (ie.length != 12)
                    return false;
                nro = new Array(12);
                for (let i = 0; i <= 11; i++)
                    nro[i] = parseInt(ie.charAt(i));
                soma = (nro[0] * 1) + (nro[1] * 3) + (nro[2] * 4) + (nro[3] * 5) + (nro[4] * 6) + (nro[5] * 7) + (nro[6] * 8) + (nro[7] * 10);
                dig = soma % 11;
                if (dig >= 10)
                    dig = 0;
                if (dig != nro[8])
                    return false;
                soma = (nro[0] * 3) + (nro[1] * 2) + (nro[2] * 10) + (nro[3] * 9) + (nro[4] * 8) + (nro[5] * 7) + (nro[6] * 6) + (nro[7] * 5) + (nro[8] * 4) + (nro[9] * 3) + (nro[10] * 2);
                dig = soma % 11;
                if (dig >= 10)
                    dig = 0;
                return (dig === nro[11]);
                break;

            case "TO":
                return true;
                // if (ie.length != 9)
                //     return false;
                // s = ie.substring(2, 4);
                // if ((s != "01") && (s != "02") && (s != "03") && (s != "99"))
                //     return false;
                // nro = new Array(11);
                // b = 9;
                // soma = 0;
                // for (let i = 0; i <= 9; i++) {
                //     nro[i] = parseInt(ie.charAt(i));
                //     if (i != 2 && i != 3) {
                //         soma += nro[i] * b;
                //         b--;
                //     }
                // }
                // resto = soma % 11;
                // dig = 0;
                // if (resto < 2) {
                //     dig = 0;
                // } else {
                //     dig = 11 - resto;
                // }
                // return (dig === parseInt(ie.charAt(10)));
                break;

            default:
                return false;

        }
    },
    GerarStringAleatoria() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      
        for (var i = 0; i < 20; i++)
          text += possible.charAt(Math.floor(Math.random() * possible.length));
      
        return text;
    },
    IsCEP(strCEP, blnVazio) {
        // Caso o CEP não esteja nesse formato ele é inválido!
        let objER   = /^[0-9]{2}[0-9]{3}-[0-9]{3}$/;
        strCEP      = this.Trim(strCEP)
        if (strCEP.length > 0) {
            if (objER.test(strCEP))
                return true;
            else
                return false;
        }
        else
            return blnVazio;
    },
    contemstring(strprincipal, strpesquisar){
        let n = strprincipal.search(strpesquisar);        
        return n > 0 ? true : false;
    },
    formatarfone(v) {
        try{
            if (v !== ''){
                let r = v.replace(/\D/g, "");
                r = r.replace(/^0/, "");
                if (r.length > 10) {
                    r = r.replace(/^(\d\d)(\d{5})(\d{4}).*/, "($1) $2-$3");
                } else if (r.length > 5) {
                    r = r.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, "($1) $2-$3");
                } else if (r.length > 2) {
                    r = r.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
                } else {
                    r = r.replace(/^(\d*)/, "($1");
                }
                return r;
            }else{
                return '';
            }
        }
        catch(e) {
            return v;
        }
    },
    arredondaValores(valor, casasDecimais, tipoarredonda) {
        casasDecimais = typeof casasDecimais != 'undefined' ?  casasDecimais : 2;

        switch(tipoarredonda) {
            case 'round':
                //Somente Arredonda
                return +(Math.round(valor + ('e+' + casasDecimais)) + ('e-' + casasDecimais));
                break;
            case 'floor':
                //Arrendona para Menos
                return +(Math.floor(valor + ('e+' + casasDecimais)) + ('e-' + casasDecimais));
                break;
            case 'ceil':
                //Arrendonda para Mais
                return +(Math.ceil(valor + ('e+' + casasDecimais)) + ('e-' + casasDecimais));
                break;
            default:
                //Arrendona para Menos
                return +(Math.round(valor + ('e+' + casasDecimais)) + ('e-' + casasDecimais));
        }
    },
    arredondaValoresRound(value, exp) {
        //Somente Arredonda
        return decimalAdjust('round', value, exp);
    },
    arredondaValoresFloor(value, exp) {
        //Arrendona para Menos
        return decimalAdjust('floor', value, exp);
    },
    arredondaValoresCeil(value, exp) {
        //Arrendonda para Mais
        return decimalAdjust('ceil', value, exp);
    },
    mtdcarregaprecotabela(lsttabela, idtabela){
        if (lsttabela) {
            for (var i = 0; i < lsttabela.length; i++) {
                if (parseInt(lsttabela[i]['idtabela']) === parseInt(idtabela) ){
                    return parseFloat(lsttabela[i]['prtabela']);
                }    
            }
        }
        return 0;
    },
    mtdcarregaprecoservicofilial(lstprecos, idfilial){
        if (lstprecos) {            
            for (var i = 0; i < lstprecos.length; i++) {
                if (parseInt(lstprecos[i]['idfilial']) === parseInt(idfilial) ){
                    return lstprecos[i];
                }    
            }
        }
        return 0;
    },
    somaDias(dt, qtd){
        var dt1  = dt.split("/");
        var hj1  = dt1[2]+"-"+dt1[1]+"-"+dt1[0];
        var dtat = new Date(hj1);

        dtat.setDate(dtat.getDate());
        var myDate = new Date(hj1);

        myDate.setDate(myDate.getDate() + (qtd+1));
        var ano = myDate.getFullYear();
        var dia = myDate.getDate(); if(dia<10){dia='0'+dia};
        var mes = (myDate.getMonth()+1); if(mes<10){mes='0'+mes}   

        return (dia+"/"+mes+"/"+ano);
    },
    IsDate(data) {
        if (data.length === 10) {
            let er = /(0[0-9]|[12][0-9]|3[01])[-\.\/](0[0-9]|1[012])[-\.\/][0-9]{4}/;
            if (data === '00/00/0000'){
                return false;
            }else {
                if (er.exec(data)) {
                    return true;
                } else {
                    return false;
                }
            }
        } else {
            return false;
        }
    },
    spliter(str, nr) {//divide umas string em várias partes
        const parts = [];
        for (let i = 0, length = str.length; i < length; i += nr) {
            parts.push(str.substring(i, i + nr));
        }
        return parts;
    },
    extensaoarquivo(arquivo){
        var value = arquivo.name;
        var values = value.split('.'); 
        if (values.length > 0){
            return values[values.length - 1];
        } else {
            return '';
        }        
    },
    setfocus(elemento){
        $(elemento).focus();
    },
    primeiramaiuscula(text) {
        try{
            if (text !== '') {
                let texto = text.toLowerCase()
                return texto[0].toUpperCase() + texto.slice(1);
            } else {
                return '';
            }
        }
        catch(e) {
            return text;
        }
    },
    irfinaldiv(iddiv){
        let div = $(iddiv)[0];
        div.scrollTop = div.scrollHeight;  
    },
    download(content, filename, contentType){
        if(!contentType){
            contentType = 'application/octet-stream';
        }
        let a = document.createElement('a');
        let blob = new Blob([content], {'type':contentType});
        a.href = window.URL.createObjectURL(blob);
        a.download = filename;
        a.click();
    },
    gerardadoslegendagrafico(arraydados){
        let dadoslegenda = [];
        for (let item of arraydados) {
            dadoslegenda.push(item.name);
        }
        return dadoslegenda;
    },
    dataextenso(datainf){
        let data    = datainf;
        data        = new Date(data.replace(/ /g,"T"));
        let day     = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"][data.getDay()];
        let date    = data.getDate();
        let month   = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"][data.getMonth()];
        let year    = data.getFullYear();
        return day+', '+date+' de '+month+' de '+year;
    },
    datamenor(datainf){
        let hoje  = this.InverterData(this.DataAtual(true, false));
        return moment(datainf).isAfter(hoje);
    },
    gerarseriegrafico(arraydados, campo){
        let dados = [];
        for (let item of arraydados) {
            dados.push(item[campo]);
        }
        return dados;
    }, 
    valBalanca(codigo){
        let nTam = 0;
        let sCod = '';

        sCod = codigo.toString().trim();
        nTam = sCod.length;

        if(sCod.substring(0,1) === '2' && nTam === 13) {
            return true;
        }else{
            return false;
        }
    },
    ver_ean(numero, digito){
        let cNum = '';
        let nTam = 0;
        let cDig = '';

        cNum = numero.trim();
        nTam = cNum.length;
        cDig = this.retDigEAN(cNum, digito);

        if(cDig === nTam) {
            return true;
        }else{
            return false;
        }
    },
    retDigEAN(numero, digito){
        let factor = 3;
        let sum    = 0;
        let cc     = 0;
        let numlen = 0;
        let index  = 0;

        for(index = numero.length; index > 0; --index){
            sum = sum + numero.substring (index-1, index) * factor;
            factor = 4 - factor;
        }

        cc = ((1000 - sum) % 10);

        digito = cc;
        numlen = numero.length;

        if (numlen > 17){
            digito = "";
            //alert("O número deve possuir no máximo 17 dígitos");
        }

        if (((((numlen != 7) && (numlen != 11)) && (numlen != 12)) && (numlen != 13)) && (numlen != 17)){
            digito = "";
            //alert("O número deve possuir 7 (EAN/UCC-8), 11 (UCC-12), 12 (EAN/UCC-13), 13 (EAN/UCC-14) ou 17 (SSCC) dígitos");
            return numlen;
        }else{
            return numlen;
        }
    },
    isDecimal(num) {
        return (parseInt(num) != parseFloat(num)) && !isNaN(num);
    },
    diferencaentredatas(dtmaior, dtmenor){
        let now = moment(dtmaior); // Data de hoje
        let past = moment(dtmenor); // Outra data no passado
        let duration = moment.duration(now.diff(past));
        
        // Mostra a diferença em dias
        return duration.asDays();        
    },
    rotinacoletor(context, item, opcoletor, mtdexecutar, adrsrv){
        let vself = context;
        let loader = vself.$loading.show();
        let parametros      = [
            {parametro: 'dbcliente',    valor : vself.$store.state.usuario.dbcliente},
            {parametro: 'op',           valor : parseInt(opcoletor) === 4 ? 'limparcoletor' : 'rotinacoletor'},
            {parametro: 'opcoletor',    valor : opcoletor},
            {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
            {parametro: 'item',         valor : JSON.stringify(item)}
        ];
        let retorno     = this.reqaxios(parametros, 'post', adrsrv+'/controller/rotinasusuario.php');
        retorno.then(function (response) {
            loader.hide();
            if ($.isNumeric(response.data.inf)){
                mtdexecutar(response.data.itenscoletor);
            }else{
                mtdexecutar([]);
            }
        }).catch(function (response) {
            loader.hide();
            mtdexecutar([]);
        });        
    },
    atzitenscoletor(context, itens, atz){
        let payloads = {
            atualizar    : atz,
            itenscoletor : itens
        };
        context.$store.commit('ATUALIZAR_ITENSCOLETOR_CHANGE',payloads);                 
    },
    atzverificalib(context, atz){
        let payloads = {
            verificar    : atz
        };
        context.$store.commit('VERIFICAR_LIBERACAO_SISTEMA',payloads);                 
    },
    pri_ult_diames(datames, formatada){
        let dtbase   		= datames; // data do mês para verificar
        let datasretornomes = [];
        let primeirodiames  = new Date(dtbase.getFullYear(), dtbase.getMonth(), 1);
        let ultimodiames 	= new Date(dtbase.getFullYear(), dtbase.getMonth() + 1, 0);
        if (!formatada) {
            return datasretornomes = {
                'primeirodiames' : primeirodiames,
                'ultimodiames'   : ultimodiames
            };
        }else{
            return datasretornomes = {
                'primeirodiames' : this.formatarzeros(primeirodiames.getDate(), 2) + '/' + this.formatarzeros(primeirodiames.getMonth()+1, 2) + '/' + primeirodiames.getFullYear(),
                'ultimodiames'   : this.formatarzeros(ultimodiames.getDate(), 2) + '/' + this.formatarzeros(ultimodiames.getMonth()+1, 2) + '/' + ultimodiames.getFullYear()
            };
        }
    },
    itemcomimposto(dadosclasseitem, vlunitario, qtditem, descacres, valdescacres){
        let totalsemimposto = 0;
        let pipi		 = parseFloat(dadosclasseitem.pipi);
        if (isNaN(pipi)){
            pipi = 0;
        }				
        let vlipi		 = 0;
        let picms		 = parseFloat(this.getValInArray(dadosclasseitem.campos, 'idcampo', 'pICMS',   'valor'));
        if (isNaN(picms)){
            picms = 0;
        }
        let vlicms		 = 0;
        let pmvast	 	 = parseFloat(this.getValInArray(dadosclasseitem.campos, 'idcampo', 'pMVAST',  'valor'));
        if (isNaN(pmvast)){
            pmvast = 0;
        }
        let vlbcicmsst   = 0;
        let vlmvast		 = 0;
        let picmsst		 = parseFloat(this.getValInArray(dadosclasseitem.campos, 'idcampo', 'pICMSST', 'valor'));
        if (isNaN(picmsst)){
            picmsst = 0;
        }				
        let vlicmsst	 = 0;
    
        switch (parseInt(descacres)){
            case 0://Desconto
                totalsemimposto 	= (qtditem * vlunitario) - valdescacres;					
                break;
            case 1://Acrescimo
                totalsemimposto 	= (qtditem * vlunitario) + valdescacres;
                break;
        }				
        vlipi		= totalsemimposto  * pipi / 100;
        vlicms   	= totalsemimposto  * picms / 100;
        vlmvast  	= (totalsemimposto + vlipi) * pmvast / 100;
        vlbcicmsst  = totalsemimposto  + vlipi + vlmvast;
        let icmsst 	= vlbcicmsst * picmsst / 100;
        if (parseInt(dadosclasseitem.calcularnopedido) === 1){
            vlicmsst	= icmsst - vlicms;
        }else{
            vlicmsst    = 0;
        }
        let ret = {
            totalimpostoitem : (vlicmsst).toFixed(3),
            vltotalitem		 : (parseFloat(totalsemimposto) + parseFloat((vlicmsst).toFixed(3))).toFixed(2)
        }
        return ret;
    },
    aplicaselecao(lista, campo, valoratribuir){
        for (var i = 0; i < lista.length; i++) {
            lista[i][campo] = valoratribuir;
        }
    },
    marcartodas(lista, campo){
        if (this.findValInArray(lista, campo, 0)){
            this.aplicaselecao(lista, campo, 1);
        }else{
            this.aplicaselecao(lista, campo, 0);
        }
    },
    habilita(lista, campo, index){
        if (parseInt(lista[index][campo]) === 0) {
            lista[index][campo] = 1;
        } else {
            lista[index][campo] = 0;
        }
    },
    diasemanaintmysql(){//retorna o dia da semana no índice do mysql
        const d = new Date();
        let day = d.getDay()
        return parseInt(day)+1;
    }    
} 
Number.prototype.formatMoney = function(places, symbol, thousand, decimal) {
	places = !isNaN(places = Math.abs(places)) ? places : 2;
	symbol = symbol !== undefined ? symbol : "$";
	thousand = thousand || ",";
	decimal = decimal || ".";
	var number = this, 
	    negative = number < 0 ? "-" : "",
	    i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
	    j = (j = i.length) > 3 ? j % 3 : 0;
	return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
};
